import React from "react";
import Divider from "@mui/material/Divider";

function DgDivider() {
  return (
    <Divider
      sx={(theme) => ({
        position: "relative",
        borderBottom: "3px solid",
        borderBottomColor: "#ebbc62",
        ...theme.applyStyles("dark", {
          borderBottomColor: "#CF9C4C",
        }),
        margin: "0.5rem 0",
      })}
    />
  );
}

export default DgDivider;
